import FTourDictionary from '@/modules/Tour/Dictionary/index';

export default class FTourDictionaryCity extends FTourDictionary {
  dictionary = 'city';

  constructor(props = {}) {
    super(props);
    this.departure = props.departure;
  }

  get departure() {
    return this.refs.data.departure;
  }

  set departure(value) {
    if (!value) {
      return;
    }
    this.refs.data.departure = value;
    this.refs.set('departure', value);
  }

  __formatting({ cities = [] }) {
    return super.__formatting(cities);
  }
}
